import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    isTitle: true,
    plans: ['essential', 'basic', 'growth', 'premium']
  },
  {
    id: 2,
    label: 'MENUITEMS.NEWDASHBOARD.TEXT',
    icon: 'ri-dashboard-2-line',
    link: 'overview',
    plans: ['basic', 'growth', 'premium']
  },
//   {
//     id: 2,
//     label: 'MENUITEMS.DASHBOARDCLIENT.TEXT',
//     icon: 'ri-dashboard-2-line',
//     link: '',
//     plans: ['basic', 'growth', 'premium']
//   },
  {
    id: 3,
    label: 'MENUITEMS.LEADLIST.TEXT',
    icon: 'ri-account-circle-line',
    link: 'my-leads',
    plans: ['essential', 'basic', 'growth', 'premium']
  },
//   {
//     id: 4,
//     label: 'MENUITEMS.CALENDAR.TEXT',
//     icon: 'ri-calendar-2-line',
//     link: 'calendar',
//     plans: ['essential', 'basic', 'growth', 'premium']
//   },
//   {
//     id: 5,
//     label: 'MENUITEMS.BLACKOUTDAYS.TEXT',
//     icon: 'ri-shut-down-line',
//     link: 'blackout-day',
//     plans: ['basic', 'growth', 'premium']
//   },
//   {
//     id: 6,
//     label: 'MENUITEMS.TRANSACTIONS.TEXT',
//     icon: 'ri-list-check-2',
//     link: 'transaction',
//     plans: ['essential', 'basic', 'growth', 'premium']
//   },
//   {
//     id: 7,
//     label: 'MENUITEMS.BILLING.TEXT',
//     icon: 'ri-list-check-2',
//     link: 'profile-setting/payments',
//     plans: ['essential', 'basic', 'growth', 'premium']
//   },
 {
    id: 7,
    label: 'MENUITEMS.BILLING.TEXT',
    icon: 'ri-list-check-2',
    link: 'billing',
    plans: ['essential', 'basic', 'growth', 'premium']
  },
//   {
//     id: 8,
//     label: 'MENUITEMS.TUTORIAL.TEXT',
//     icon: 'ri-rocket-line',
//     link: 'tutorial',
//     plans: ['basic', 'growth', 'premium']
//   },

  // {
  //   id: 8,
  //   label: 'Wallet',
  //   icon: 'ri-wallet-3-line',
  //   link: 'wallet'
  // },
  // {
  //   id: 8,
  //   label: 'tasks',
  //   icon: 'ri-wallet-3-line',
  //   link: 'tasks/details'
  // }
   {
    id: 9,
    label: 'MENUITEMS.MYREQUEST.TEXT',
    icon: 'ri-list-check-2',
    link: 'my-requests',
    plans: ['essential', 'basic', 'growth', 'premium'],
	subItems: [
		{
			id: 91,
			label: 'MENUITEMS.BLACKOUTDAYS.TEXT',
			link: 'blackout-day',
			parentId: 9,
		},
		{
			id: 92,
			label: 'MENUITEMS.REPLACEMENTS.TEXT',
			link: 'my-request/replacements',
			parentId: 9,
		},
		{
			id: 93,
			label: 'MENUITEMS.RESCHEDULE.TEXT',
			link: 'my-request/reschedule',
			parentId: 9,
		},
		{
			id: 94,
			label: 'Support Tickets',
			link: 'support-tickets',
			parentId: 9,
		},
	],
  },
];
